import type { DashboardQueryDto } from '../../types/analytics';

// Shared by every dashboard widget so RTK Query serializes the same cache key
// and the page fires a single /analytics/dashboard request per poll cycle.
export const DASHBOARD_QUERY: DashboardQueryDto = {
  period: 'today',
  includeRealTime: true,
  includeTrends: false,
  includeAlerts: false,
};

export const DASHBOARD_POLLING_MS = 30000;
